var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cmp-header"},[_c('h1',[_c('span',{staticClass:"btn-back",on:{"click":_vm.back}},[_c('van-icon',{attrs:{"name":"arrow-left"}})],1),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }